// A light tick under the finger: on Android the Vibration API; on an iPhone,
// which has none, the tick iOS 18 gives a switch-style checkbox when it
// toggles, from a hidden one. Off with $prefs.phoneHaptics = false.
// Copied from hutchies/imperium src/imperium/ui/phone/haptics.js.
//
// Browsers only allow either in answer to the user: a tap always works, a
// hold timing out or a finger sliding may stay silent on iOS.
import { get } from 'svelte/store';
import { prefs } from '../stores.js';

let label = null;
function iosSwitch(){
    if(label) return label;
    const input = document.createElement('input');
    input.type = 'checkbox';
    input.setAttribute('switch', '');
    input.id = 'stcc-haptic';
    label = document.createElement('label');
    label.htmlFor = input.id;
    label.setAttribute('aria-hidden', 'true');
    for(const el of [input, label]) Object.assign(el.style, { position: 'fixed', left: '-100px', top: '0', width: '1px', height: '1px', opacity: '0', pointerEvents: 'none' });
    document.body.append(input, label);
    return label;
}

export function haptic(){
    if(typeof navigator == 'undefined' || get(prefs).phoneHaptics === false) return;
    if(typeof navigator.vibrate === 'function'){ navigator.vibrate(8); return; }
    if(/iP(hone|ad|od)/.test(navigator.userAgent)) iosSwitch().click();
}
